import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getWesterosDocumentListPaginated, IDocumentListResponse } from "api";
import { Nullable } from "config";
import { DocumentModalMode, RootState } from "store";

import { IWesterosDocumentListModalData } from "./types";

const initialState = {
  documentList: null as Nullable<IDocumentListResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: DocumentModalMode.VIEW,
  } as IWesterosDocumentListModalData,
};

export const fetchWesterosDocumentList = createAsyncThunk(
  "westeros-document-list/fetchWesterosDocumentList",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getWesterosDocumentListPaginated(filters);
    return response;
  }
);

const westerosDocumentListSlice = createSlice({
  name: "westeros-document-list",
  initialState,
  reducers: {
    setWesterosDocumentListModalData: (state, action) => {
      state.modalData = action.payload;
    },
    closeWesterosDocumentListModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWesterosDocumentList.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        documentList: action.payload?.edges ?? null,
        totalCount: action.payload?.totalCount ?? 1,
      };
    });
    builder.addCase(fetchWesterosDocumentList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setWesterosDocumentListModalData,
  closeWesterosDocumentListModal,
} = westerosDocumentListSlice.actions;

export default westerosDocumentListSlice.reducer;
